export default {
    en: {
        imageSplitter: {
            title: 'Free Image Splitter',
            description: 'Online image splitter tool - fast, easy and free.',
            uploadText: 'Drag and drop your image here \n or click to browse',
            uploadButtonText: 'Upload Image',
            splitMode: 'Split Mode',
            rows: 'Rows',
            columns: 'Columns',
            preview: 'Preview',
            clear: 'Clear',
            download: 'Download',
        },
    }
}